export default "__VITE_ASSET___R9d162k__"